import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Styles from '../Style/Common.module.css';
import BtnStyle from '../Style/Button.module.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CustomButtonGroup from "../Common/CustomButtonGroup";
//icon
import { RxArrowTopRight } from "react-icons/rx";
//image api
import constants from "../../services/constants";

const TQsector = ({ data }) =>{

  const sectorSlide = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 767 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 1
    }
  };
  return(
    <div className={'sectorBlock ' + Styles.sectorSec}>
      <Container fluid>
        <Row>
          <Col>
            <div className={Styles.servicesContainer}>
              <h2 className={Styles.title} data-aos="fade-up" data-aos-delay="200">Industry Footprint</h2>
              <p className={Styles.subTitle} data-aos="fade-up" data-aos-delay="500">Trusted Across Industries for Integrity, Impact, and Innovation</p>
            </div>
          </Col>
        </Row>
      </Container>
      <div className={'navBtn sectorNav ' + Styles.commonOwl + " " + Styles.topSpace} data-aos="fade-up" data-aos-delay="700">
        <Carousel
            autoPlaySpeed={3000}
            transitionDuration={500}
            responsive={sectorSlide}
            autoPlay={true}
            infinite={true}
            arrows={false}
            customButtonGroup={<CustomButtonGroup />}
            renderButtonGroupOutside={true}
            containerClass="sectorOwl"
        >
          {data &&
            [...data]
              .sort((a, b) => a.order - b.order)
              .map((item, index) => (
                <div className={Styles.sectorItem} key={index}>
                  <div className={Styles.itemBox}>
                    <img
                      src={`${constants.Image_BASE_URL}${item.image}`}
                      alt={item.title}
                    />
                    <h3>{item.title}</h3>
                  </div>
                </div>
            ))}
        </Carousel>
      </div>
    </div>
  )
}

export default TQsector;